import React, { CSSProperties } from "react";
import styled from "styled-components";

type Props = {
  style?: CSSProperties;
  className?: string;
  margin?: string;
  float?: string;
};

export default class InlineMiddleSpan extends React.PureComponent<Props> {
  render() {
    let STYLE = {};
    if (this.props.style) {
      STYLE = Object.assign(STYLE, this.props.style);
    } else if (this.props.margin) {
      STYLE = Object.assign(STYLE, { margin: this.props.margin });
    } else if (this.props.float) {
      STYLE = Object.assign(STYLE, { float: this.props.float });
    }
    return (
      <SpanWrap className={this.props.className} style={STYLE}>
        {this.props.children}
      </SpanWrap>
    );
  }
}

const SpanWrap = styled.div<Props>`
  display: inline-block;
  vertical-align: middle;
`;
